var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-button"},[_c('button',{style:(_vm.dynamicStyle),on:{"click":_vm.click}},[(_vm.icon != null)?_c('i',{class:'fas ' + _vm.icon}):_vm._e(),(_vm.title != null)?_c('p',[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }